
<template>
  <div>
    <v-card flat>
      <v-checkbox label="Não possui conta" v-model="noAccount"></v-checkbox>
      <v-card-title class="d-flex justify-center align-center">
        <template v-if="!noAccount">
          <v-tabs v-model="tab">
            <v-tab v-for="idx in account_count" :key="idx">
              Conta {{ idx }}
            </v-tab>
          </v-tabs>
          <div >
            <v-btn icon @click="changeAccountCount(false)" v-if="account_count > 1">
              <v-icon large color="error">mdi-minus</v-icon>
            </v-btn>
            <v-btn icon @click="changeAccountCount(true)" v-if="account_count < 2">
              <v-icon large color="light-blue">mdi-plus</v-icon>
            </v-btn>
          </div>
        </template>
      </v-card-title>
      <v-card-text v-if="!noAccount">
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="idx in account_count" :key="idx">
            <BankAccountForm ref="form" only_cpf :account="employee.accounts[number_map[idx]]"></BankAccountForm>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="emitChangeStepper(false)"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
        <f-btn save @click="emitChangeStepper(true)"></f-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'EmployeeBankStepper',
  props:{
    employee: {
      type: Object,
      default: () => { return {} }
    }
  },
  components:{
    BankAccountForm: () => import("@/_backoffice/_registrations/components/shared/forms/BankAccountForm.vue"),
  },
  data() {
    return {
      tab: 0,
      noAccount: false,
      account_count: 1,
      number_map:{
        1 : 'primary',
        2 : 'secondary', 
      }
    }
  },
  methods: {
    validate(){
      if(this.noAccount){
        return true
      }else{
        let is_valid = true 
        for(let idx = 0; idx < this.account_count; idx++){
          is_valid = is_valid && this.$refs.form[idx].validate()
        }
        return is_valid
      }
    },
    emitChangeStepper(increment){
      if(increment && !this.noAccount){
        this.prepareAccount()
      }
      this.$emit("changeStepper", increment)
    },
    changeAccountCount(incremento) {
      if (incremento) {
        this.account_count += 1;
        if (this.account_count > 3) {
          this.account_count = 1;
        }
      }else {
        this.account_count -= 1;
        if (this.account_count < 2) {
          this.account_count = 1;
          this.resetBank()
        }
      }
    },
    prepareAccount() {
      this.employee.accounts_attributes = []
      for(let idx = 1; idx <= this.account_count; idx++){
        if (this.employee.accounts[this.number_map[idx]].bank_id) {
          this.employee.accounts_attributes.push(this.employee.accounts[this.number_map[idx]])
        }
      }
    },
    resetBank(){
      this.employee.accounts.secondary.bank = '';
      this.employee.accounts.secondary.account = '';
      this.employee.accounts.secondary.titular = '';
      this.employee.accounts.secondary.titularCPF = '';
    },
  },
}
</script>